import { apiSlice } from '../../../app/api/apiSlice';
import Config from '../../../configs/appConfig';
import makeQueryParams from '../../../lib/makeQueryParams';



export const TemplatesApiSlice = apiSlice.injectEndpoints({
  tagTypes: [ 'Templates', 'Template' ],
  endpoints: (builder) => {
    return ({
      getTemplates: builder.query({
        query: (params) => {
          const queryParams = makeQueryParams(params.queryParams);

          return ({ url: `/${Config.VITE_HC_API_VERSION}/templates${queryParams}` });
        },
        transformResponse: (response) => {
          return {
            data: response?.data,
            pagination: response?.meta?.pagination,
          };
        },
        transformErrorResponse: (response) => response?.data?.errors,
        providesTags: [ 'Templates' ],
        keepUnusedDataFor: 1,
      }),
      getTemplateContentTypes: builder.query({
        query: () => ({ url: `/${Config.VITE_HC_API_VERSION}/templates/types` }),
        transformResponse: (response) => response?.data,
        providesTags: [ 'Templates' ],
      }),
      createTemplate: builder.mutation({
        query: ({ payload }) => {
          return ({
            url: `/${Config.VITE_HC_API_VERSION}/templates`,
            method: 'POST',
            body: payload,
          });
        },
        invalidatesTags: () => [ 'Templates' ],
      }),
      getTemplate: builder.query({
        query: (params) => {
          const baseUrl = `/${Config.VITE_HC_API_VERSION}/templates/${params.id}`;
          const includeParam = params?.include ? `?include=${params.include}` : '';

          return { url: baseUrl + includeParam };
        },
        transformResponse: (response) => {
          return { data: response?.data };
        },
        providesTags: [ 'Template' ],
        keepUnusedDataFor: 1,
      }),
      getTemplateVisualizationsKeys: builder.query({
        query: (id) => ({
          url: `/${Config.VITE_HC_API_VERSION}/templates/${id}/visualizations`,
          method: 'GET',
        }),
        transformResponse: (response) => {
          return { data: response?.data };
        },
        providesTags: [ 'Template' ],
        keepUnusedDataFor: 1,
      }),
      updateTemplate: builder.mutation({
        query: ({ id, payload }) => ({
          url: `/${Config.VITE_HC_API_VERSION}/templates/${id}`,
          method: 'PUT',
          body: payload,
        }),
        invalidatesTags: () => [
          'Templates', 'Template', 'Collections', 'CollectionsItem', 'Popups', 'PopupsItem',
          'Features', 'FeaturesItem', 'DynamicNews', 'DynamicNewsItem', 'Presets', 'Preset',
          'LocalNotifications', 'LocalNotificationItem', 'PushNotifications', 'PushNotificationItem',
          'Categories', 'CategoryItem', 'Events', 'EventItem', 'Stickers', 'StickerItem',
        ],
      }),
      cloneTemplate: builder.mutation({
        query: (id) => ({
          url: `/${Config.VITE_HC_API_VERSION}/templates/${id}/clones`,
          method: 'POST',
        }),
        invalidatesTags: () => [ 'Templates', 'Template' ],
      }),
      deleteTemplate: builder.mutation({
        query: (id) => ({
          url: `/${Config.VITE_HC_API_VERSION}/templates/${id}`,
          method: 'DELETE',
        }),
        invalidatesTags: () => [ 'Templates' ],
      }),
    });
  },
});

export const {
  useGetTemplatesQuery,
  useGetTemplateContentTypesQuery,
  useGetTemplateQuery,
  useGetTemplateVisualizationsKeysQuery,
  useCloneTemplateMutation,
  useDeleteTemplateMutation,
  useCreateTemplateMutation,
  useUpdateTemplateMutation,
} = TemplatesApiSlice;
